// src/Components/conferencePages/CallForPaper.js
import React from "react";
import { FaHandPointRight } from "react-icons/fa";
import styles from "./CallForPaper.module.css";
import { BrainCircuit } from "lucide-react";
import cvision from "../../assets/icons/computer-vision.png";
import precognition from '../../assets/icons/pattern-recognition.png'

export default function CallForPaper() {
  return (
    <div className={styles.container}>
      <section className={styles.section1}>
        <div className={styles.cont}>
          <span className={styles.icon}>
            <BrainCircuit
              style={{ display: "inline", position:'relative', top:'5px' }}
              size={28}
              fill="white"
            />
          </span>
          <span className={styles.right}>
            <h1 className={styles.heading}>
              Track 1: Machine Learning: Models and Applications
            </h1>{" "}
          </span>
        </div>
        <ul>
          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Advances in Statistical Learning and Neural Network Models
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Learning Paradigms Inspired by Evolutionary Computation
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Machine Learning for Multilingual Representation, Information Retrieval, and Web Mining
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Green AI: Sustainable and Energy-Efficient Machine Learning Approaches
              </p>
            </span>
          </li>
      
          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Federated and Distributed Learning for Privacy-Preserving AI Applications
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Edge Intelligence: Machine Learning at the Edge of IoT and 5G Networks
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Machine Learning Approaches for Biomedical and Computational Biology Applications
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Data-Driven Solutions in Engineering, Economics, Business, and Education
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Machine Learning for Industrial Automation, Smart Urban Systems, and Autonomous Vehicles
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                AI-Driven Security Mechanisms for Cloud Computing, IoT, and UAV Networks
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Human-Centered AI: Machine Learning for Interaction, Ethics, and Society
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Advances in Hybrid and Innovative Machine Learning Algorithms
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Role of Optimization in Machine Learning Algorithms
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                AI-Enabled Cyber-Physical Systems for Intelligent Automation
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Performance Evaluations of Various Machine Learning Algorithms
              </p>
            </span>
          </li>
        </ul>
      </section>

      {/* National Advisory Committee */}
      <section className={styles.section2}>
        <div className={styles.cont}>
          <span className={styles.icon}>
            <img
              src={cvision}
              style={{ display: "inline", position:'relative', top:'5px', fill: "white", width: '30px', height:'30px' }}
              alt=""
            />
          </span>
          <span className={styles.right}>
            <h1 className={styles.heading}>
              Track 2: Computer Vision and Image Understanding
            </h1>{" "}
          </span>
        </div>
        <ul>
          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                AI-Driven Image and Video Acquisition, Coding, and Analysis
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Intelligent Path Planning Algorithms for Mobile Robots
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                3D Vision, LiDAR, Shape and Texture Analysis
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                AI-Driven Image Retrieval and Semantic Understanding
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Recognition: Detection, Categorization, Indexing, Matching and Retrieval
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Earth Observation and Remote Sensing Image Interpretation
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Quantum-Based Image Understanding and Processing
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Advances in Human-Centric Computer Vision: Face, Body, Pose, and Gesture
              </p>
            </span>
          </li>
         
          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Next-Generation Deep learning Architectures and Techniques
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Cognitive and Biologically Inspired Vision Applications
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Intelligent Motion Analysis: Detection and Tracking of Objects
              </p>
            </span>
          </li>
          
          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Secure Image Processing: Encryption and Privacy Preserving Mechanisms
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Exploring Computer Vision for Autonomous Driving and Navigation
              </p>
            </span>
          </li>


          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Deep Representation Learning Approaches to Image Restoration and Enhancement
              </p>
            </span>
          </li>
          
          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Strengthening Computer Vision Applications: Applying and Evaluating New Datasets
              </p>
            </span>
          </li>

        </ul>
      </section>

      {/* Local Advisory Committee */}
      <section className={styles.section3}>
        <div className={styles.cont2}>
          <span className={styles.icon}>
            <img
              src={precognition}
              style={{ display: "inline", position:'relative', top:'5px', fill: "white", width: '30px' }}
              alt=""
            />
          </span>
          <span className={styles.right}>
            <h1 className={styles.heading}>
              Track 3: Pattern Recognition and Decision-Making Systems
            </h1>{" "}
          </span>
        </div>
        <ul>
          <li className={styles.listcont2}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Signal Representation, Transformation, and Feature Extraction using Pattern Recognition
              </p>
            </span>
          </li>

          <li className={styles.listcont2}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Biometric and Behavioural Pattern Recognition for Authentication
              </p>
            </span>
          </li>

          <li className={styles.listcont2}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Image Enhancement and Compression for Medical and Multispectral Imaging
              </p>
            </span>
          </li>

          <li className={styles.listcont2}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Human Activity Mining for Personalized Smart Home Automation
              </p>
            </span>
          </li>

          <li className={styles.listcont2}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Generative AI for Data Augmentation in Pattern Recognition
              </p>
            </span>
          </li>
          
          <li className={styles.listcont2}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Machine Vision Applications in Industrial Settings
              </p>
            </span>
          </li>

          <li className={styles.listcont2}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Multilingual Pattern Recognition for Cross-Language NLP Applications
              </p>
            </span>
          </li>

          <li className={styles.listcont2}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                3D Face and Gesture Recognition via Holographic Imaging Patterns
              </p>
            </span>
          </li>
          
          <li className={styles.listcont2}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Multi-Objective Emotion Recognition through Fusion of Physiological Patterns
              </p>
            </span>
          </li>

          <li className={styles.listcont2}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Multi-View Geometry–Based Recognition for Various Scene Understanding
              </p>
            </span>
          </li>

          <li className={styles.listcont2}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Pattern Recognition for Compression, Watermarking, and Multimedia Security
              </p>
            </span>
          </li>

          <li className={styles.listcont2}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Multimodal Fusion for Object Detection and Recognition via Pattern Learning
              </p>
            </span>
          </li>

          <li className={styles.listcont2}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Pattern Recognition in Big Data, IoT, UAVs and Edge Computing
              </p>
            </span>
          </li>

          <li className={styles.listcont2}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Hybrid Model for Pattern Recognition Architectures via Sensor Data Fusion
              </p>
            </span>
          </li>

          <li className={styles.listcont2}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Quantum Computing for Energy-Efficient Pattern Recognition on Edge Devices
              </p>
            </span>
          </li>

          <li className={styles.listcont2}>
            <span className={styles.listicon}>
              <FaHandPointRight color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Case Studies of Pattern Recognition (e.g. Healthcare, Environment, Business, etc.)
              </p>
            </span>
          </li>
        </ul>
      </section>
    </div>
  );
}
